import { makePendencySimulationsRepository } from 'modules/customer/infra/repositories';

import { FetchPendencySimulationsUseCase } from './implementations/FetchPendencySimulationsUseCase';

let instance: FetchPendencySimulationsUseCase | null = null;

export default function makeFetchPendencySimulationsUseCase() {
  if (!instance) {
    const repository = makePendencySimulationsRepository();

    instance = new FetchPendencySimulationsUseCase(repository);
  }

  return instance;
}
